// extracted by mini-css-extract-plugin
export default {"body":"Radio_body__9M8sO","labelWrapper":"Radio_labelWrapper__8xcp1","label":"Radio_label__e4ABM","inner":"Radio_inner__+S9OM"};